<template>
    <div>
        <a-result
            :title="$t('user.security.tfa.step_2.title')"
            :sub-title="$t('user.security.tfa.step_2.sub_title')"
            v-if="tfa_option == 'app'"
        >
            <template #icon>
                <QrcodeOutlined class="icon-color" />
            </template>
            <template #extra>
                <div>
                    <img :src="tfa_qrcode_url" alt="qr_code" :class="{ 'm-auto pb-4': tfa_enforced }" />
                </div>

                <div class="section-body">
                    <div data-cy="field-tfa-code" class="input-container full pb-4">
                        <ui-label>
                            {{ $t('user.security.tfa.labels.code') }}
                        </ui-label>
                        <ui-input v-model="tfa_code" :placeholder="$t('user.security.tfa.placeholders.code')" />
                        <span class="text-help" :class="{ 'text-left': tfa_enforced }">
                            {{ $t('user.security.tfa.help.code') }}
                        </span>
                    </div>
                </div>
                <div class="text-right">
                    <a-button v-if="!tfa_enforced" @click="cancelTFA" data-cy="tfa-cancel-button">
                        {{ $t('user.security.tfa.cancel') }}
                    </a-button>
                    <a-button v-if="tfa_enforced" @click="goBackTFA" data-cy="tfa-go-back-button">
                        {{ $t('user.security.tfa.go_back') }}
                    </a-button>
                    <a-button
                        type="primary"
                        @click="submitTFAOption"
                        :loading="tfa_processing"
                        data-cy="tfa-next-step-2-button"
                    >
                        {{ $t('user.security.tfa.continue') }}
                    </a-button>
                </div>
            </template>
        </a-result>

        <a-result :title="$t('user.security.tfa.step_2.title')" v-if="tfa_option == 'email'">
            <template #icon>
                <MailOutlined class="icon-color" />
            </template>
            <template #extra>
                <div class="section-body">
                    <div data-cy="field-tfa-code" class="input-container full pb-4">
                        <ui-label>
                            {{ $t('user.security.tfa.labels.email') }}
                        </ui-label>
                        <ui-input v-model="tfa_code" :placeholder="$t('user.security.tfa.placeholders.email')" />
                        <span class="text-help" :class="{ 'text-left': tfa_enforced }">
                            {{ $t('user.security.tfa.help.code_email') }}
                        </span>
                    </div>
                </div>
                <div class="text-right">
                    <a-button v-if="!tfa_enforced" @click="cancelTFA" data-cy="tfa-cancel-button">
                        {{ $t('user.security.tfa.cancel') }}
                    </a-button>
                    <a-button v-if="tfa_enforced" @click="goBackTFA" data-cy="tfa-go-back-button">
                        {{ $t('user.security.tfa.go_back') }}
                    </a-button>
                    <a-button
                        type="primary"
                        @click="submitTFAOption"
                        :loading="tfa_processing"
                        data-cy="tfa-next-step-2-button"
                    >
                        {{ $t('user.security.tfa.continue') }}
                    </a-button>
                </div>
            </template>
        </a-result>
    </div>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';
import UiLabel from '@/components/ui/Label.vue';
import { MailOutlined, QrcodeOutlined } from '@ant-design/icons-vue';

export default {
    components: {
        UiInput,
        UiLabel,
        MailOutlined,
        QrcodeOutlined,
    },
    props: {
        tfa_enforced: {
            type: Boolean,
            default: false,
        },
        tfa_option: {
            type: String,
            default: '',
        },
        tfa_qrcode_url: {
            type: String,
            default: '',
        },
        tfa_processing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tfa_code: '',
        };
    },
    methods: {
        cancelTFA() {
            this.$emit('cancelTFA');
        },
        goBackTFA() {
            this.$emit('goBackTFA');
        },
        submitTFAOption() {
            this.$emit('submitTFAOption', this.tfa_code);
        },
    },
};
</script>
